import { useState } from 'react';
import { SecondaryButtonMedium } from '@/components/base/Buttons';
import { PageSectionLarge } from '@/components/base/Sections';
import { TypographyH6, TypographyText, TypographyTitle } from '@/components/base/Typography';
import { PrimaryInput } from '@/components/form/Inputs';

const footerLinks = {
  shop: [
    { name: 'Engagement Rings', href: '/rings' },
    { name: 'Loose Diamonds', href: '/diamonds' },
  ],
  education: [
    { name: 'Diamond Education', href: '/education/lab-grown-vs-natural-diamonds' },
    { name: 'Ring Size Guide', href: '/education/ring-size-guide' },
    { name: 'Ring Guide', href: '/education/types-of-rings' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Blog', href: '/education' },
  ],
};

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<string | null>(null);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) return;

    try {
      const res = await fetch('/api/klaviyo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, createDiscount: false }),
      });

      if (res.ok) {
        setStatus('Thank you for subscribing! ');
        setEmail('');
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch {
      setStatus('Something went wrong. Please try again.');
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Newsletter Sign Up */}
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="mt-8 pt-8 text-center">
          <TypographyTitle className="text-white">Stay in the loop</TypographyTitle>
        </div>
        <div className="mx-auto mb-8 max-w-lg space-y-4 text-center">
          <TypographyText className="block">
            Join our newsletter to get updates on new diamonds & exclusive offers.
          </TypographyText>

          <form
            onSubmit={handleSubscribe}
            className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
          >
            <PrimaryInput
              type="email"
              required
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 text-black"
            />
            <SecondaryButtonMedium type="submit">Subscribe</SecondaryButtonMedium>
          </form>
          {status && <TypographyText className="block">{status}</TypographyText>}
        </div>
      </div>

      {/* Main Footer Content */}
      <PageSectionLarge>
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5">
          {/* Company Info */}
          <div className="space-y-4 lg:col-span-2">
            <TypographyTitle className="text-white">Dream Diamonds</TypographyTitle>
            <TypographyText>
              Canada's #1 diamond marketplace, trusted by over 50,000+ couples. We provide
              transparent pricing and expert guidance to help you find the perfect diamond for your
              special moment.
            </TypographyText>
          </div>

          {/* Shop Links */}
          <div className="space-y-4">
            <TypographyH6 className="text-white">Shop</TypographyH6>
            <ul className="space-y-4">
              {footerLinks.shop.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="transition-colors hover:text-white">
                    <TypographyText>{link.name}</TypographyText>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Education Links */}
          <div className="space-y-4">
            <TypographyH6 className="text-white">Education</TypographyH6>
            <ul className="space-y-4">
              {footerLinks.education.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="transition-colors hover:text-white">
                    <TypographyText>{link.name}</TypographyText>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div className="space-y-4">
            <TypographyH6 className="text-white">Our Company</TypographyH6>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="transition-colors hover:text-white">
                    <TypographyText>{link.name}</TypographyText>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-gray-800 pt-8">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 md:justify-start">
            {/* <a href="/privacy" className="transition-colors hover:text-white">
              <TypographyText className="text-muted-foreground">Privacy Policy</TypographyText>
            </a>
            <a href="/terms" className="transition-colors hover:text-white">
              <TypographyText className="text-muted-foreground">Terms of Service</TypographyText>
            </a> */}
          </div>
          <div className="text-center md:text-right">
            <TypographyText>&copy; 2025 Dream Diamonds. All rights reserved.</TypographyText>
          </div>
        </div>
      </PageSectionLarge>
    </footer>
  );
};
